module.exports = __webpack_public_path__ + "img/num_32.7b1d8b8a.png";